document.addEventListener("DOMContentLoaded", () => {
  const ddButton = document.querySelector(".vag__dd-button");
  const ddIcon = ddButton.querySelector("svg");
  const dropdown = document.querySelector(".vag__dd");

  function openDropdown() {
    dropdown.classList.add("vag__dd--open");
    ddIcon.classList.add("rotated");
  }
  function closeDropdown() {
    dropdown.classList.remove("vag__dd--open");
    ddIcon.classList.remove("rotated");
  }
  ddButton.addEventListener("click", () => {
    dropdown.classList.contains("vag__dd--open")
      ? closeDropdown()
      : openDropdown();
  });
});
